import common from "../common";
import Scene from "./Scene";
import {translate} from "../utils";
import {Easing, Tween} from "@tweenjs/tween.js";
import FlockController from "../game/flocking/FlockController";

export default class SplashScene extends Scene {

    constructor() {
        super();
    }

    init() {
        super.init();

        this._bg = new PIXI.Sprite(P3.assets.texture("bg_splash_screen"));
        this._bg.width = common.STAGE_WIDTH;
        this._bg.height = common.STAGE_HEIGHT;
        this._bg.interactive = true;
        this._bg.mousedown = this._bg.touchstart = this._onSceneDown.bind(this);
        this.addChild(this._bg);

        this._title = new PIXI.Sprite(P3.assets.texture("title"));
        this._title.anchor.set(0.5);
        this._title.position.set(common.STAGE_WIDTH * 0.5, common.STAGE_HEIGHT * 0.5 - 200);
        this._title.visible = false;
        this.addChild(this._title);

        this._logo = new PIXI.Sprite(P3.assets.texture("show_logo"));
        this._logo.anchor.set(0.5);
        this._logo.position.set(common.STAGE_WIDTH * 0.5 + 310, common.STAGE_HEIGHT * 0.5 - 100);
        this._logo.visible = false;
        this.addChild(this._logo);

        this._eyeHolder = new PIXI.Container();
        this._eyeHolder.visible = false;
        this.addChild(this._eyeHolder);

        // create eyes
        let points = [
            // left
            new PIXI.Point(common.STAGE_WIDTH * 0.5 - 300, common.STAGE_HEIGHT * 0.5 + 60),
            new PIXI.Point(common.STAGE_WIDTH * 0.5 - 380, common.STAGE_HEIGHT * 0.5 + 240),
            new PIXI.Point(common.STAGE_WIDTH * 0.5 - 420, common.STAGE_HEIGHT * 0.5 - 80),
            new PIXI.Point(common.STAGE_WIDTH * 0.5 - 520, common.STAGE_HEIGHT * 0.5 + 80),
            // right
            new PIXI.Point(common.STAGE_WIDTH * 0.5 + 320, common.STAGE_HEIGHT * 0.5 + 120),
            new PIXI.Point(common.STAGE_WIDTH * 0.5 + 360, common.STAGE_HEIGHT * 0.5 - 240),
            new PIXI.Point(common.STAGE_WIDTH * 0.5 + 490, common.STAGE_HEIGHT * 0.5 + 10),
            new PIXI.Point(common.STAGE_WIDTH * 0.5 + 520, common.STAGE_HEIGHT * 0.5 - 160)
        ];

        for (let i = 0; i < points.length; i++) {

            const eyes = new PIXI.Sprite(P3.assets.texture("eyes_0" + i));
            eyes.position = points[i];
            eyes.anchor.set(0.5);
            this._eyeHolder.addChild(eyes);

            this.eyesTween(eyes);
        }

        // ghosts
        points = [
            // left
            new PIXI.Point(common.STAGE_WIDTH * 0.5 - 180, common.STAGE_HEIGHT * 0.5 + 140),
            new PIXI.Point(common.STAGE_WIDTH * 0.5 + 190, common.STAGE_HEIGHT * 0.5 + 120),
            new PIXI.Point(common.STAGE_WIDTH * 0.5 - 10, common.STAGE_HEIGHT * 0.5 + 20)
        ];

        for (let i = 0; i < points.length; i++) {
            const ghost = new PIXI.Sprite(P3.assets.texture("ghost_0" + i));
            ghost.position = points[i];
            ghost.anchor.set(0.5);
            this.addChild(ghost);

            this.floatyTween(ghost);
        }

        this._flockHolder = new PIXI.Container();
        this.addChild(this._flockHolder);

        const settings = {
            limits: {velocity: 320, force: 8},
            weights: {s: 1.3, a: 0.9, c: 0.8, t: 1.1},
            separation: 60,
            sense: 300,
            targeting: false,
            wrapAround: false,
            bounds: new PIXI.Rectangle(0, 0, common.STAGE_WIDTH, common.STAGE_HEIGHT - 100)
        };

        this._flockHolder.y = -common.STAGE_HEIGHT * 0.25;
        this._flock = new FlockController(this._flockHolder, settings);
        this._flock.populate(6);
        this._flock.wake();

        this._flockHolder2 = new PIXI.Container();
        this.addChild(this._flockHolder2);

        const settings2 = {
            limits: {velocity: 320, force: 8},
            weights: {s: 1.3, a: 0.9, c: 0.8, t: 1.1},
            separation: 60,
            sense: 300,
            targeting: false,
            wrapAround: false,
            bounds: new PIXI.Rectangle(0, 0, common.STAGE_WIDTH, common.STAGE_HEIGHT - 100)
        };

        this._flockHolder2.y = -common.STAGE_HEIGHT * 0.25;
        this._flock2 = new FlockController(this._flockHolder2, settings2);
        this._flock2.populate(4);
        this._flock2.wake();

        // instead of trying to change anchor points use a container to do the idle tween
        this._characterHolder = new PIXI.Container();
        this._characterHolder.position.set(common.STAGE_WIDTH * 0.5, common.STAGE_HEIGHT);
        this.addChild(this._characterHolder);

        this._characters = new PIXI.Sprite(P3.assets.texture("scooby_shaggy"));
        this._characters.anchor.set(0.5);
        this._characters.position.set(0, -this._characters.height * 0.5);
        this._characters.visible = false;
        this._characterHolder.addChild(this._characters);

        const states = new P3.ButtonStates();
        states.normal = P3.assets.texture("btn_tertiary_small_out");
        states.over = P3.assets.texture("btn_tertiary_small_over");
        states.down = P3.assets.texture("btn_tertiary_small_down");
        states.icon = P3.assets.texture("icon_sound_on");
        states.iconAlt = P3.assets.texture("icon_sound_off");

        this._muteButton = new P3.MuteButton(states);
        this._muteButton.clickSoundName = "sfx_click";
        this._muteButton.overSoundName = "sfx_rollover";
        this._muteButton.visible = false;
        this._muteButton.signals.up.add(function () {
            common.saveData.data.mute = !P3.audio.isMuted();
            common.saveData.save();
        }, this);
        this._muteButton.cursor = 'hover';
        this.addChild(this._muteButton);

        this._playButton = P3.Button.create(
            P3.assets.texture("btn_primary_large_out"),
            P3.assets.texture("btn_primary_large_over"),
            P3.assets.texture("btn_primary_large_down"),
            P3.assets.texture("icon_play")
        );
        this._playButton.clickSoundName = "sfx_click";
        this._playButton.overSoundName = "sfx_rollover";
        this._playButton.signals.click.once(this.onPlayButtonClick, this);
        this._playButton.visible = false;
        this._playButton.cursor = 'hover';
        this.addChild(this._playButton);

        this._boomerangLogo = new PIXI.Sprite(P3.assets.texture("boomerang_logo"));
        this._boomerangLogo.anchor.set(0.5);
        this.addChild(this._boomerangLogo);

        this.floatyTween(this._title);

        P3.utils.delayg(this._tweens, 0.8, () => {
            this.floatyTween(this._logo);
        });

    }

    resize() {
        super.resize();

        /*
        this._muteButton.position.set((common.STAGE_WIDTH - P3.View.width) * 0.5 + 90, 90);
        this._playButton.position.set((common.STAGE_WIDTH + P3.View.width) * 0.5 - 140, common.STAGE_HEIGHT - 160);
        this._boomerangLogo.position.set((common.STAGE_WIDTH - P3.View.width) * 0.5 + 90, common.STAGE_HEIGHT - 60);

         */

        this._muteButton.position.set((common.STAGE_WIDTH - P3.View.width) * 0.5 + 90, 90);
        this._playButton.position.set((common.STAGE_WIDTH + P3.View.width) * 0.5 - 140, common.STAGE_HEIGHT - 160);
        this._boomerangLogo.position.set((common.STAGE_WIDTH - P3.View.width) * 0.5 + 90, common.STAGE_HEIGHT - 60);

    }

    animateIn() {

        /*

        new Tween(this._characterHolder.scale, this._tweens)
            .to({x: 0.9, y: 1.1}, 800)
            .easing(Easing.Quadratic.InOut)
            .yoyo(true)
            .repeat(Infinity)
            .start();

         */

        new P3.utils.TWEEN.Tween(this._characterHolder.scale, this._tweens)
            .to({x: 1.02, y: 0.98}, 1400)
            .easing(Easing.Quadratic.InOut)
            .yoyo(true)
            .repeat(Infinity)
            .start();

        this._characters.scale.set(0.2);
        new P3.utils.TWEEN.Tween(this._characters.scale, this._tweens)
            .delay(190)
            .onStart(() => this._characters.visible = true)
            .to({x: 1, y: 1}, 410)
            .easing(P3.utils.TWEEN.Easing.Quadratic.Out)
            .onComplete(() => {


            })
            .start();


        /*
        this._characters.rotation = -Math.PI * 0.2;
        const a = new P3.utils.TWEEN.Tween(this._characters, this._tweens)
            .delay(190)
            .to({rotation: Math.PI * 0.01}, 410)
            .easing(P3.utils.TWEEN.Easing.Quadratic.Out);

        const b = new P3.utils.TWEEN.Tween(this._characters, this._tweens)
            .to({rotation: -Math.PI * 0.001}, 2910)
            .yoyo(true)
            .repeat(Infinity)
            .easing(P3.utils.TWEEN.Easing.Quadratic.InOut);

        a.chain(b);
        a.start();

         */

        this._title.scale.set(0.2);
        const c = new P3.utils.TWEEN.Tween(this._title.scale, this._tweens)
            .delay(690)
            .onStart(() => this._title.visible = true)
            .to({x: 1, y: 1}, 420)
            .onComplete(() => {

            })
            .easing(P3.utils.TWEEN.Easing.Back.Out);

        this._logo.scale.set(0.2);
        const d = new P3.utils.TWEEN.Tween(this._logo.scale, this._tweens)
            .delay(190)
            .onStart(() => this._logo.visible = true)
            .to({x: 1, y: 1}, 420)
            .onComplete(() => {

            })
            .easing(P3.utils.TWEEN.Easing.Back.Out);

        this._muteButton.scale.set(0.2);
        const e = new P3.utils.TWEEN.Tween(this._muteButton.scale, this._tweens)
            .delay(190)
            .onStart(() => this._muteButton.visible = true)
            .to({x: 1, y: 1}, 420)
            .easing(P3.utils.TWEEN.Easing.Back.Out);

        this._playButton.scale.set(0.2);
        const f = new P3.utils.TWEEN.Tween(this._playButton.scale, this._tweens)
            .onStart(() => this._playButton.visible = true)
            .to({x: 1, y: 1}, 420)
            .onComplete(() => {
                this._eyeHolder.visible = true;
                this._eyeHolder.alpha = 0;

                new P3.utils.TWEEN.Tween(this._eyeHolder, this._tweens)
                    .to({alpha: 1}, 420)
                    .easing(P3.utils.TWEEN.Easing.Quadratic.InOut)
                    .start();
            })
            .easing(P3.utils.TWEEN.Easing.Back.Out);

        c.chain(d);
        d.chain(e);
        e.chain(f);

        c.start();

    }

    floatyTween(obj, startTime = 0) {

        new Tween(obj, this._tweens)
            .to({x: obj.x - 10, y: obj.y + 10}, P3.math.randomInt(1600, 2400))
            .repeat(Infinity)
            .yoyo(true)
            .easing(Easing.Quadratic.InOut)
            .start(startTime);

        const rotTime = P3.math.randomInt(1800, 2900);

        const rotLeft = new Tween(obj, this._tweens)
            .to({rotation: -Math.PI * 0.05}, rotTime)
            .yoyo(true)
            .repeat(1)
            .easing(Easing.Quadratic.InOut);

        const rotRight = new Tween(obj, this._tweens)
            .to({rotation: Math.PI * 0.05}, rotTime)
            .yoyo(true)
            .repeat(1)
            .easing(Easing.Quadratic.InOut);

        // chain infinetly
        rotLeft.chain(rotRight);
        rotRight.chain(rotLeft);
        rotLeft.start(startTime);
    }

    eyesTween(obj, startTime = 0) {

        const rotTime = P3.math.randomInt(1800, 2900);

        const rotLeft = new Tween(obj, this._tweens)
            .to({rotation: -Math.PI * 0.05}, rotTime)
            .yoyo(true)
            .repeat(1)
            .easing(Easing.Quadratic.InOut);

        const rotRight = new Tween(obj, this._tweens)
            .to({rotation: Math.PI * 0.05}, rotTime)
            .yoyo(true)
            .repeat(1)
            .easing(Easing.Quadratic.InOut);

        // chain infinetly
        rotLeft.chain(rotRight);
        rotRight.chain(rotLeft);
        rotLeft.start(startTime);
    }

    destroy() {
        // clean up goes here
        super.destroy();
    }

    update(dt = window.deltaTime) {
        super.update();
        this._flock.update(dt);
        this._flock2.update(dt);
    }

    end() {
        this._bg.interactive = false;
        this.signals.next.dispatch();
    }

    onPlayButtonClick() {
        this.end();
    }

    _onSceneDown(event) {
        if (this._flock.targeting)
            return;

        // flock to target then stop flocking after a random delay
        this._flock.target = event.data.getLocalPosition(this._flockHolder);
        this._flock.targeting = true;
        P3.utils.delayg(this._tweens, P3.math.random(2, 4), () => this._flock.targeting = false);
    }
}